import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { BsArrowRight, BsArrowBarDown } from 'react-icons/bs';
import { useParams, useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';  // Importer le toast
import Hospitallogo from '../../../assets/images/Frame 1000005869.png';
import Codeqrimg from '../../../assets/images/codeqr.png';
import html2canvas from 'html2canvas';
import api from '../../../service/caller';
import { usePermissions } from '../../../contexts/PermissionContext';



const PatientCard = () => {
    const { patientId } = useParams();  // Récupérer l'ID du patient depuis l'URL
    const [patientData, setPatientData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { UserData } = usePermissions();  // Récupérer les données de l'utilisateur connecté
    const [systemColor, setSystemColor] = useState('#00AC93'); // Couleur par défaut
    // Fonction pour récupérer les données du patient
    useEffect(() => {
        const fetchPatientData = async () => {
            try {
                const response = await api.get(`/clinic/getpatient/${patientId}`);  // Remplacer par votre API
                setPatientData(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Erreur lors de la récupération des données du patient', error);
                setError('Erreur lors de la récupération des données.');
                setLoading(false);
            }
        };

        if (patientId) {
            fetchPatientData();
        }
    }, [patientId]);  // Recharger les données si l'ID change

    const handleDownload = async () => {
        const element = document.querySelector('.receipt-container');
        if (!element) return;

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 210; // A4 width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            pdf.save(`${patientData.patientId}_PatientCard.pdf`);
        } catch (error) {
            console.error('Erreur de génération PDF:', error);
        }
    };

    // Utiliser useEffect pour changer la couleur du système
    useEffect(() => {
        const fetchSystemColor = async () => {
            try {
                const response = await api.get('/clinic/system-settings'); // Remplacez par votre API
                if (response.data && response.data.primaryColor) {
                    setSystemColor(response.data.primaryColor);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération de la couleur du système', error);
            }
        };

        fetchSystemColor();
    }, []); // Appel de l'API une seule fois lors du chargement du composant

    // Fonction pour la redirection avec le toast de succès
    const handleValidate = () => {
        // Afficher le toast de succès
        toast.success("Patient ajouté avec succès!", {
            position: "top-right",  // Utilisation de la chaîne de caractères pour la position
            autoClose: 3000,
        });

        // Rediriger vers la page des patients
        navigate('/hospitaladmin/patientlist');
    };


    if (loading) {
        return <div>Loading...</div>;  // Afficher un message de chargement
    }

    if (error) {
        return <div>{error}</div>;  // Afficher un message d'erreur si la récupération échoue
    }

    if (!patientData) {
        return <div>Aucun patient trouvé.</div>;  // Si aucune donnée de patient n'est trouvée
    }



    // Card style
    const cardStyle = {
        backgroundColor: systemColor,
        padding: '20px 20px',
        color: 'white',
        borderRadius: '20px',
    };

    return (
        <div className="patientcard">
            <CModal
                className="ticket newregistermodal"
                alignment="center"
                scrollable
                size="lg"
                visible={true}
                onClose={() => { }}
            >
                <CModalHeader className="text-center">
                    <CModalTitle className="Titleformsmodal"><p className='text-center'>Register new Patient</p> </CModalTitle>
                </CModalHeader>
                <CModalBody className="p-5 d-flex flex-column align-items-center">
                    {/* Rendu du reçu avec les données de paymentData */}
                    <div className="receipt-container border p-4 bg-white shadow">
                        <div className="d-flex align-items-center mb-3 justify-content-between p-3">
                            <img src={UserData?.hospital_id[0]?.picture || Hospitallogo} className='me-auto' alt="Clinic Logo" style={{ width: '150px', height: 'auto', borderRadius:'15px' }} />
                            {/* <img src={Hospital.logo} className='me-auto' alt="Clinic Logo" style={{ width: '150px', height: 'auto' }} /> */}
                            <h5 className="fw-2">PATIENT CARD</h5>
                        </div>
                        <div className='patientinfocontent' style={cardStyle}>
                            <div className='patientinfo row'>
                                <div className='qrimg col-md-5'>
                                    <img src={patientData.qrCode} alt="QR Code Patient" className='W-100' />
                                    {/* <img src={Codeqrimg} alt="qr image" style={{ width: '80px' }} /> */}
                                </div>
                                <div className='patientinfo col-md-6 d-flex flex-column justify-content-center'>
                                    <div className='textdivright'>
                                        <h6><b>Patient information :</b></h6>
                                        <p>Name : <span>{patientData.lastname} {patientData.firstname} </span></p>
                                        <p>Code Patient : <span>{patientData.patientId}</span></p>
                                        <p>Address : <span>{patientData.address}</span> </p>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className='textdivleft'>
                                <p>Keep this card with you at all times ! Lorem  ipsum <br></br> dolor sit amet. Aut modi quas qui voluptatum maiores.</p>
                                <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>www.cliniqueoluwa.com</p>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4 btnactionpatientcard' >
                        <CButton className="w-100" style={{ backgroundColor: '#FF9800' }} onClick={handleDownload} >
                            Telecharger<BsArrowBarDown className='ms-2' />
                        </CButton>
                        <CButton className="w-100" style={{ backgroundColor: '#28A745' }} onClick={handleValidate} >
                            Save <BsArrowRight className='ms-2' />
                        </CButton>
                    </div>
                </CModalBody>
            </CModal>
        </div>
    );
};


export default PatientCard;
